import { Component } from '@angular/core';

@Component({
    selector: 'app-channel-table-header-compact',
    templateUrl: './channel-table-header-compact.component.html',
    styleUrls: ['../channel-table-header/channel-table-header.component.scss'],
    standalone: false
})
export class ChannelTableHeaderCompactComponent {}
